import PlansContainer from "../../container/admin/plans-master";

const Plans = () => {
    return <PlansContainer />;
};

export default Plans;